var render = function render(){
  var _vm$payload$event$met, _vm$payload$event$met2, _vm$payload$event$met3;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('button', {
    staticClass: "back-button-wrapper pointer",
    attrs: {
      "type": "button",
      "aria-label": "Zavrieť konzultáciu"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v(_vm._s(_vm.translateEventType(_vm.payload.event.type)))]), _vm.sliceZeros(_vm.payload.event.start.value) !== _vm.sliceZeros(_vm.eventData.start) ? _c('button', {
    staticClass: "w-button",
    attrs: {
      "form": "event-changes"
    }
  }, [_vm._v("Uložiť")]) : _vm._e()]), _vm.payload.client ? _c('button', {
    staticClass: "client-name-block consultation-client-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openClient
    }
  }, [_c('img', {
    staticClass: "image-10",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f37_avatar%20cropped.png",
      "loading": "lazy",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "div-block-28"
  }, [_c('div', {
    staticClass: "light-text lightgrey"
  }, [_vm._v(" Klient "), _c('div', {
    staticClass: "blc-color"
  }, [_c('strong', [_vm._v(_vm._s(_vm.payload.client.first_name) + " " + _vm._s(_vm.payload.client.last_name))]), _c('span', {
    staticClass: "client-details-hint"
  }, [_vm._v("Zobraziť údaje a email →")])])])])]) : _c('div', {
    staticClass: "availability-status"
  }, [_c('strong', [_vm._v("Voľný termín pre klientov")]), _c('span', [_vm._v("Termín zatiaľ čaká na rezerváciu.")])]), _c('form', {
    attrs: {
      "id": "event-changes"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.saveEvent.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "input-group mt-2"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "podnikamOd"
    }
  }, [_vm._v("Termín udalosti")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.eventData.start,
      expression: "eventData.start"
    }],
    staticClass: "text-input w-input date-input",
    attrs: {
      "type": "datetime-local",
      "min": _vm.todayLong,
      "maxlength": "256",
      "name": "podnikamOd",
      "data-name": "podnikamOd",
      "id": "podnikamOd",
      "required": ""
    },
    domProps: {
      "value": _vm.eventData.start
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.eventData, "start", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "non-input-block"
  }, [_vm.payload.event.type === 'online_konzultacia' ? _c('div', [_c('div', {
    staticClass: "small-text light"
  }, [_vm._v(" Video call: ")]), !_vm.payload.event.is_available_for_booking ? [_c('button', {
    staticClass: "join-call-button",
    attrs: {
      "type": "button",
      "disabled": _vm.joining
    },
    on: {
      "click": _vm.joinCall
    }
  }, [_vm._v(" " + _vm._s(_vm.joining ? 'Pripájam…' : 'Pripojiť sa cez Daily') + " ")]), _vm.payload.client ? _c('button', {
    staticClass: "copy-call-button",
    attrs: {
      "type": "button",
      "disabled": _vm.copying
    },
    on: {
      "click": _vm.copyClientLink
    }
  }, [_vm._v(_vm._s(_vm.copying ? 'Pripravujem odkaz…' : _vm.copied ? 'Odkaz skopírovaný ✓' : 'Skopírovať odkaz pre klienta'))]) : _vm._e(), _vm.copyError ? _c('p', {
    staticClass: "join-call-note",
    attrs: {
      "role": "status"
    }
  }, [_vm._v(_vm._s(_vm.copyError))]) : _vm._e(), _vm.manualLink ? _c('div', {
    staticClass: "manual-call-link"
  }, [_c('label', {
    attrs: {
      "for": "client-call-link"
    }
  }, [_vm._v("Odkaz pre klienta — označte a skopírujte:")]), _c('textarea', {
    attrs: {
      "id": "client-call-link",
      "readonly": ""
    },
    domProps: {
      "value": _vm.manualLink
    },
    on: {
      "focus": function focus($event) {
        return $event.target.select();
      }
    }
  })]) : _vm._e(), _c('p', {
    staticClass: "join-call-note"
  }, [_vm._v("Miestnosť sa otvorí 15 minút pred začiatkom konzultácie.")])] : _c('div', {
    staticClass: "pop-700 blc-color font-size-16"
  }, [_vm._v(" Link sa vytvorí automaticky po rezervácii klientom. ")])], 2) : _c('div', [_c('div', {
    staticClass: "small-text light"
  }, [_vm._v(" Iná adresa: ")]), (_vm$payload$event$met = _vm.payload.event.meta) !== null && _vm$payload$event$met !== void 0 && _vm$payload$event$met.placeId ? _c('a', {
    staticClass: "pop-900 blc-color font-size-16 pointer overflow-hidden",
    attrs: {
      "href": 'https://www.google.com/maps/place/?q=place_id:' + ((_vm$payload$event$met2 = _vm.payload.event.meta) === null || _vm$payload$event$met2 === void 0 ? void 0 : _vm$payload$event$met2.placeId),
      "target": "_blank"
    }
  }, [_vm._v(" Navigovať ")]) : _vm._e(), (_vm$payload$event$met3 = _vm.payload.event.meta) !== null && _vm$payload$event$met3 !== void 0 && _vm$payload$event$met3.addressMeta ? _c('div', {
    staticClass: "pop-700 blc-color font-size-14"
  }, [_vm._v(" " + _vm._s(_vm.getAddressModified(_vm.payload.event.meta.addressMeta)) + " ")]) : _c('div', {
    staticClass: "pop-700 blc-color font-size-16"
  }, [_vm._v(" Adresa " + _vm._s(_vm.translateEventType(_vm.payload.event.type, 'u').toLowerCase()) + " nebola špecifikovaná ")])])]), _c('div', {
    staticClass: "section-title pointer noselect"
  }, [_c('span', {
    staticClass: "bold bl-color",
    on: {
      "click": _vm.deleteEvent
    }
  }, [_vm._v(" Vymazať udalosť ")])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }